import { Box, Button, Container, Grid, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
const image = '/1.jpg';
const logo = '/gainss-logo.png';

const AuthWrapper = ({ children }) => {
  const location = useLocation();

  const isLoginPage = location.pathname.includes('login');
  const isRegisterPage =
    location.pathname.includes('register') ||
    location.pathname.includes('change-password');

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box className="d-flex justify-content-between align-items-center p-3">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            cursor: 'pointer',
            marginTop: '0.4rem',
          }}
          onClick={() => {
            window.location = '/';
          }}>
          <img src={logo} width="125" alt="GAINSS" />
        </Box>

        {isLoginPage ? (
          <>
            <Typography
              variant="body1"
              sx={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
              color="primary">
              Don&apos;t have an account?
              <Button
                variant="outlined"
                color="primary"
                component={Link}
                to="/register"
                sx={{ ml: 1 }}>
                Register
              </Button>
            </Typography>
          </>
        ) : isRegisterPage ? (
          <Typography
            variant="body1"
            sx={{
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
            }}
            color="primary">
            Already have an account?
            <Button
              variant="outlined"
              color="primary"
              component={Link}
              to="/login"
              sx={{ ml: 1 }}>
              Login
            </Button>
          </Typography>
        ) : null}
      </Box>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ flexGrow: 1, px: 2 }}>
        <Grid item md={7}>
          <img src={image} alt="default" style={{ maxWidth: '100%' }} />
        </Grid>
        <Grid item md={5}>
          <Box sx={{ p: 3 }}>{children}</Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
            }}
          >
          <Button
            variant="text"
            color="primary"
            onClick={() => window.open('https://gainss.ai/', '_blank')}
          >
            About us
          </Button>

          <Box component="span" sx={{ color: 'primary.main'}}>
            |
          </Box>

          <Button
            variant="text"
            color="primary"
          onClick={() => window.open('https://globaltestingexperts.com/contact-us/', '_blank')}
          >
            Contact
          </Button>
        </Box>

        </Grid>
      </Grid>
    </Container>
  );
};

export default AuthWrapper;
